const config = {
    api: 'https://strapi.specskolytrebic.cz'
}

export default config;
